import {
  getTableColumnsFromProperties,
  getTemplateVisibleProperties
} from "PFApp/components/table_properties/helpers";
import { useCustomTypes } from "PFCore/helpers/use_custom_types";
import { useCurrentProfile } from "PFCore/hooks/queries/profile";
import { TableColumn, Template } from "PFCore/types";
import { useMemo } from "react";

type UseAvailableWithCustomTypesColumns = {
  blockedProperties: string[];
  template: Template | undefined;
  availableColumns: TableColumn[];
  sectionKey?: string;
};
type UseAvailableWithCustomTypesColumnsReturn = {
  availableWithCustomTypesColumns: TableColumn[];
  customTypesColumns: TableColumn[];
};

export const useAvailableWithCustomTypesColumns = ({
  blockedProperties,
  template,
  availableColumns,
  sectionKey
}: UseAvailableWithCustomTypesColumns): UseAvailableWithCustomTypesColumnsReturn => {
  const { data: currentProfile } = useCurrentProfile();
  const { customTypes } = useCustomTypes();

  const customTypesColumns = useMemo(() => {
    const visibleTemplateProperties = getTemplateVisibleProperties(
      customTypes,
      currentProfile,
      blockedProperties!,
      template,
      sectionKey
    );

    return getTableColumnsFromProperties(visibleTemplateProperties) as TableColumn[];
  }, [blockedProperties, customTypes, currentProfile, template, sectionKey]);

  const availableWithCustomTypesColumns = useMemo(
    () => availableColumns.concat(customTypesColumns as TableColumn[]),
    [availableColumns, customTypesColumns]
  );

  return {
    availableWithCustomTypesColumns,
    customTypesColumns
  };
};
